import React, { useState, useEffect } from "react";
import { ColorArray } from "../../config/ColorArray";
import { useParams, useSearchParams } from "react-router-dom";
import subjectService from "../../utils/Uchchmadhymik/subjectService";
import "./UMadhyamik.css";
import Loader from "../../common/Loader";

const STREAMS = ["arts", "commerce", "science"];

const Umadhyamik = () => {
  const { standardId, standardIndex } = useParams();
  const [searchParams] = useSearchParams();

  const standardFromQuery = searchParams.get("standardId");
  const standardKey = standardId || standardIndex || standardFromQuery;

  const [selectedStream, setSelectedStream] = useState("arts"); // Default to arts
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [streamNames, setStreamNames] = useState({});

  // 🔹 Standard label
  const getStandardLabel = (key) => {
    if (String(key) === "63") return "ધોરણ 11";
    if (String(key) === "64") return "ધોરણ 12";
    return `Standard ${key}`;
  };

  // 🔹 Load stream names
  useEffect(() => {
    const loadStreamNames = async () => {
      try {
        const response = await subjectService.getStreamNames();
        setStreamNames(response.data);
      } catch (error) {
        console.error("Error loading stream names:", error);
      }
    };
    loadStreamNames();
  }, []);

  // 🔹 Load subjects when standard or stream changes
  useEffect(() => {
    const loadSubjects = async () => {
      if (!standardKey) return;

      setLoading(true);
      try {
        const standard = String(standardKey) === "63" ? 11 : 12;
        const response = await subjectService.getSubjectsByStandardAndStream(standard, selectedStream);
        setSubjects(response.data);
      } catch (error) {
        console.error("Error loading subjects:", error);
        setSubjects([]);
      } finally {
        setLoading(false);
      }
    };
    loadSubjects();
  }, [standardKey, selectedStream]);

  return (
    <div className="umadhyamik-container">
      {/* Heading */}
      <h1>{getStandardLabel(standardKey)}</h1>

      {/* 🔘 Stream Selector */}
      <div className="stream-tabs">
        {STREAMS.map((stream) => (
          <button
            key={stream}
            className={`stream-btn ${selectedStream === stream ? "active" : ""
              }`}
            onClick={() => setSelectedStream(stream)}
          >
            {streamNames[stream] || stream}
          </button>
        ))}
      </div>

      {/* Subjects Heading */}
      <div className="subject-heading-container">
        <div className="heading-line"></div>
        <div className="subject-heading-text">
          {getStandardLabel(standardKey)} {streamNames[selectedStream]} ના વિષયો
        </div>
        <div className="heading-line"></div>
      </div>

      {/* Subjects Grid */}
      <ul className="subject-list">
        {loading ? (
          <div className="loader-container">
            <Loader />
          </div>
        ) : subjects.length === 0 ? (
          <li className="subject-item empty">No subjects found</li>
        ) : (
          subjects.map((subject, index) => {
            // Get color from ColorArray based on subject index
            const colorData = ColorArray[index % ColorArray.length];
            const color1 = colorData ? colorData.color1 : '#968bf7';
            const color2 = colorData ? colorData.color2 : '#1c00ff';

            // Create linear gradient from color1 (top) to color2 (bottom)
            const gradientStyle = `linear-gradient(to bottom, ${color1}, ${color2})`;

            return (
              <li
                key={subject.kram}
                className="subject-item"
                style={{
                  background: gradientStyle
                }}
                onClick={() => {
                  console.log(`Selected subject: ${subject.title}`);
                  // Add navigation logic here
                }}
              >
                <span className="subject-icon">
                  <img src={subject.image} alt={subject.title} style={{ width: '30px', height: '30px' }} />
                </span>
                <span className="subject-name">{subject.title}</span>
              </li>
            );
          })
        )}
      </ul>
    </div>
  );
};

export default Umadhyamik;
